//@flow
import React from 'react';

import {
  IconButton,
  LinearProgress,
  Typography,
  makeStyles,
} from '@material-ui/core';
import type {Theme} from '@material-ui/core';
import {useConversationAvailableStatus} from '../../../../../utils/message';
import {colors} from '../../../../../../../../assets/styles/colors';
import {Close, NoteAddOutlined} from '@material-ui/icons';

import type {ChatServiceType} from '../../../../../../../../entities';
import {getServiceGradient} from '../../../../../../constans';
import {useCurrentConversation} from '../../../../../utils/conversation';

type StyleProps = {
  service?: ChatServiceType,
};

const useStyles = (props: StyleProps) =>
  makeStyles((theme: Theme) => ({
    root: {
      width: '100%',
      maxWidth: '30rem',
      padding: '1rem',
      borderRadius: '1rem',
      background: 'white',
      boxShadow: 'rgba(17, 12, 46, 0.1) 0px 0px 32px 0px',
      display: 'flex',
      flexDirection: 'column',
      gap: '.25rem',
    },
    header: {
      display: 'flex',
      gap: '.5rem',
      alignItems: 'center',
    },
    textBold: {
      fontWeight: 600,
    },
    titleText: {
      fontSize: '.8rem',
      fontWeight: 600,
      color: colors.grey700,
    },
    messageText: {
      fontSize: '.8rem',
      fontWeight: 400,
      color: colors.grey700,
    },
    progress: {
      borderRadius: '1rem',
      overflow: 'hidden',
      background: getServiceGradient(props.service),
    },
    progressContainer: {
      width: '100%',
      background: colors.grey300,
      borderRadius: '1rem',
      overflow: 'hidden',
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: colors.grey700,
      marginTop: '.125rem',
    },
  }));

type Props = {
  onClose: () => void,
};

export default function TimeLimitContent({onClose}: Props) {
  const {currentConversation} = useCurrentConversation();
  const timeRestriction = useConversationAvailableStatus();
  const classes = useStyles({
    service: currentConversation && currentConversation.ravenService,
  })();

  if (!timeRestriction) return null;

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        {timeRestriction.isAvailable ? (
          <Typography className={classes.messageText}>
            <span role="img" aria-label="Reloj">
              ⏰&nbsp;
            </span>
            Recuerda, Solo tienes
            <span className={classes.textBold}>
              &nbsp;{timeRestriction.restTime}&nbsp;
            </span>
            para responder, de lo contrario se cerrará la conversación.
          </Typography>
        ) : (
          <div>
            <Typography className={classes.titleText}>
              La conversación ha finalizado
            </Typography>
            <Typography className={classes.messageText}>
              Ya no puedes responder la conversación, hasta que el usuario
              vuelva a mandar un mensaje.
            </Typography>
            {currentConversation?.ravenService === 'WHATSAPP_API' && (
              <>
                <Typography className={classes.messageText}>
                  O puedes iniciar una nueva conversación enviando un template
                  de whatsapp.
                </Typography>
                <NoteAddOutlined fontSize="default" className={classes.icon} />
              </>
            )}
          </div>
        )}
        <IconButton size="small" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </header>
      {timeRestriction.isAvailable && (
        <LinearProgress
          classes={{
            bar: classes.progress,
            root: classes.progressContainer,
          }}
          variant="determinate"
          value={timeRestriction.percentage}
        />
      )}
    </div>
  );
}
